import { render, staticRenderFns } from "./Seminat.vue?vue&type=template&id=176215f2&scoped=true"
import script from "./Seminat.vue?vue&type=script&lang=js"
export * from "./Seminat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176215f2",
  null
  
)

export default component.exports